module.exports = __webpack_public_path__ + "img/logo-top.9007d2cf.png";